import { render, staticRenderFns } from "./businessBidScoreCollect.vue?vue&type=template&id=fc0ea990&scoped=true"
import script from "./businessBidScoreCollect.vue?vue&type=script&lang=js"
export * from "./businessBidScoreCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0ea990",
  null
  
)

export default component.exports